<template>
  <div style="width: 100%">
    <div class="row">
      <div class="col-12">
        <card class="custom-shadow-card-header">
          <div class="row content-add-btn">
            <div class="col-4" v-if="isCreate()">
              <div class="text-left">
                <button
                  class="btn btn-secondary custom-shadow-btn"
                  @click="$router.push('/boxes/boxes/create')"
                >
                  <em class="fa fa-plus"></em>
                  {{ $t('production.box_add') }}
                </button>
              </div>
            </div>
            <div class="col-12 text-center">
              <hr />
            </div>
          </div>
          <div v-if="isIndex()">
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                clearable
                @clear="pagination.perPage = 10"
                class="select-default mb-3 shadow-sm"
                style="width: 200px"
                v-model="pagination.perPage"
                :placeholder="$t('common_words.per_page')"
                filterable
              >
                <el-option
                  class="select-default"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
              <el-input
                clearable
                class="mb-3 shadow-sm"
                style="width: 200px"
                :placeholder="$t('common_words.search_records')"
                v-model="searchQuery"
                aria-controls="datatables"
              />
            </div>
            <div class="col-sm-12">
              <el-table
                stripe
                :default-sort="{ prop: 'name', order: 'descending' }"
                :data="queriedData"
                height="500"
                style="width: 100%"
                :border="true"
              >
                <el-table-column
                  type="index"
                  width="65"
                  :align="'center'"
                  :resizable="false"
                >
                </el-table-column>

                <el-table-column
                  v-for="column in tableColumns"
                  :key="column.label"
                  :min-width="column.minWidth"
                  :prop="column.prop"
                  :label="column.label"
                  :fixed="column.fixed"
                  :sortable="column.sortable"
                  :align="column.align"
                  :formatter="column.formatter"
                  :resizable="false"
                >
                </el-table-column>

                <el-table-column
                  :min-width="130"
                  :label="$t('common_words.operations')"
                  fixed="right"
                  :resizable="false"
                >
                  <template slot-scope="props">
                    <div class="text-center">
                      <!-- <a
                        v-if="isShow()"
                        v-tooltip.top-center="'Administrar precios'"
                        class="btn-info btn-simple btn-link custom-margin-actions"
                        @click="handleView(props.$index, props.row)"
                      >
                        <em class="fa fa-usd custom-size-fa-actions"></em>
                      </a> -->
                      <a
                        v-if="isShow()"
                        v-tooltip.top-center="$t('common_words.view')"
                        class="btn-info btn-simple btn-link custom-margin-actions"
                        @click="handleView(props.$index, props.row)"
                      >
                        <em class="fa fa-eye custom-size-fa-actions"></em>
                      </a>
                      <a
                        v-if="isUpdate()"
                        v-tooltip.top-center="$t('common_words.edit')"
                        class="btn-warning btn-simple btn-link custom-margin-actions"
                        @click="handleEdit(props.$index, props.row)"
                      >
                        <em class="fa fa-edit custom-size-fa-actions"></em>
                      </a>
                      <a
                        v-if="isDelete()"
                        v-tooltip.top-center="$t('common_words.erase')"
                        class="btn-danger btn-simple btn-link custom-margin-actions"
                        @click="handleDelete(props.$index, props.row)"
                      >
                        <em class="fa fa-times custom-size-fa-actions"></em>
                      </a>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div v-else>
            <br />
            <h5 class="text-muted text-center">
              {{ $t('common_words.no_permissions') }}
            </h5>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class>
              <p class="card-category">
                {{ $t('table2.showing') }} {{ from + 1 }} {{ $t('table2.a') }}
                {{ to }} {{ $t('table2.of') }} {{ total }}
                {{ $t('table2.entries') }}
              </p>
            </div>
            <l-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
              pageFirst="false"
              pageLast="false"
            ></l-pagination>
          </div>
        </card>
        <div class="row" style="padding-right: 13px; padding-left: 13px">
          <div class="col-6" v-if="isPDF()">
            <div class="text-right">
              <button
                class="btn btn-danger custom-shadow-btn"
                @click="exportToPDF"
              >
                <em class="fa fa-file-pdf-o"></em>
                {{ $t('common_words.export_to_pdf') }}
              </button>
            </div>
          </div>
          <div class="col-6" v-if="isExcel()">
            <div class="text-left">
              <button
                class="btn custom-btn-success custom-shadow-btn"
                @click="exportToExcel"
              >
                <em class="fa fa-file-excel-o"></em>
                {{ $t('common_words.export_to_excel') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      v-if="isShow()"
      :title="nameAreasSelected"
      :visible.sync="modals.read"
      width="50%"
    >
      <p>
        {{ $t('common_words.selected_record_info') }}
      </p>
      <div class="card" v-if="rowData">
        <div class="card-body" v-if="rowData">
          <table class="table">
            <tbody>
              <tr class="shadow-sm">
                <td>
                  <h6>
                    <strong>{{ $t('common_words.code') }}:</strong>
                  </h6>
                  {{ rowData.code }}
                </td>
              </tr>
              <tr class="shadow-sm">
                <td>
                  <h6>
                    <strong>{{ $t('production.box_typeof') }}:</strong>
                  </h6>
                  {{ rowData.name }}
                </td>
              </tr>
              <tr class="shadow-sm">
                <td>
                  <h6>
                    <strong>{{ $t('production.stowage_typeof') }}:</strong>
                  </h6>
                  <span v-if="rowData.box_pallet">{{
                    rowData.box_pallet.pallet
                  }}</span>
                </td>
              </tr>
              <tr class="shadow-sm">
                <td>
                  <h6>
                    <strong>{{ $t('common_words.conversion_factor') }}:</strong>
                  </h6>
                  {{ formatConversionFactor(rowData.conversion_factor) }}
                </td>
              </tr>
              <tr class="shadow-sm">
                <td>
                  <h6>
                    <strong>{{ $t('production.weight_of_tara') }}:</strong>
                  </h6>
                  {{ rowData.tara_weight }} {{ rowData.unit_tara_weight }}
                </td>
              </tr>
              <tr class="shadow-sm">
                <td>
                  <h6>
                    <strong>{{ $t('production.minimum_weight') }}:</strong>
                  </h6>
                  {{ rowData.min_weight }}
                </td>
              </tr>
              <tr class="shadow-sm">
                <td>
                  <h6>
                    <strong>{{ $t('production.maximum_weight') }}:</strong>
                  </h6>
                  {{ rowData.max_weight }}
                </td>
              </tr>
              <tr class="shadow-sm">
                <td>
                  <h6>
                    <strong>{{ $t('production.box_category') }}:</strong>
                  </h6>
                  <span v-if="rowData.box_category">{{
                    rowData.box_category.name
                  }}</span>
                </td>
              </tr>
              <tr class="shadow-sm">
                <td>
                  <h6>
                    <strong>{{ $t('production.bag') }}:</strong>
                  </h6>
                  <span v-if="rowData.box_bag">{{ rowData.box_bag.bag }}</span>
                </td>
              </tr>
              <tr class="shadow-sm">
                <td>
                  <h6>
                    <strong>{{ $t('climate.rainforest') }}:</strong>
                  </h6>
                  {{ rowData.rainforest == 1 ? 'Si' : 'No' }}
                </td>
              </tr>
              <tr class="shadow-sm">
                <td>
                  <h6>
                    <strong>{{ $t('production.boxes_3lbs') }}:</strong>
                  </h6>
                  {{ rowData.box_3lb == 1 ? 'Si' : 'No' }}
                </td>
              </tr>
              <tr class="shadow-sm">
                <td>
                  <h6>
                    <strong
                      >{{ $t('production.fruit_protection_bag') }}:</strong
                    >
                  </h6>
                  {{ rowData.daypa == 1 ? 'Si' : 'No' }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="card-footer footer-date-at" v-if="rowData">
          <p class="text-white">
            <small
              >{{ $t('common_words.created_on') }}:
              {{ rowData.created_at }}</small
            >
          </p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinMenu from 'src/util/mixinMenu';
import { MixinExport } from 'src/mixins/mixin-export';
import SweetAlert from 'src/class/Alerts';
import configTable from './boxTable';
import moment from 'moment';
import { Axios } from 'src/class/Axios.js';
import i18n from 'src/i18n';
import { formatConversionFactor } from './formatConversionFactor';

export default {
  computed: {
    ...configTable().Search,
  },

  data() {
    return {
      boxForm: {},
      pagination: {},
      tableColumns: [],
    };
  },

  mixins: [mixinMasters, MixinPermissions, MixinExport, MixinMenu],

  watch: {
    '$i18n.locale': 'setupTable',
  },

  methods: {
    formatConversionFactor,

    handleView(index, row) {
      this.rowData = row;
      this.rowData.created_at = moment(
        String(this.rowData.created_at),
        'YYYY-MM-DD HH:mm:ss'
      ).format('YYYY-MM-DD hh:mm:ss');
      this.modals['read'] = true;
    },

    handleEdit(index, row) {
      row.url_path_form = '/boxes/edit';
      this.boxForm = Object.assign({}, row);
      sessionStorage.setItem('editForm', JSON.stringify(this.boxForm));
      this.$router.push({ path: 'boxes/edit' });
    },

    handleDelete(index, row) {
      this.boxForm = row;
      SweetAlert.delete(i18n.t('production.the_box') + this.boxForm.name).then(
        (result) => {
          if (result.value) this.deleteBox();
        }
      );
    },

    deleteBox() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.boxForm.route = 'boxes/boxes';
        Axios.destroyMaster(this.boxForm)
          .then((response) => this.modifyTable(2, this.boxForm.id, response))
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },

    exportToPDF() {
      this.PDF({
        route: 'boxes/boxes/pdf',
        name_file: 'cajas.pdf',
      })
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    exportToExcel() {
      this.Excel({
        route: 'boxes/boxes/excel',
        name_file: 'cajas.xlsx',
      })
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },
    setupTable() {
      const { Table } = configTable();
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
    },
  },

  created() {
    if (this.isIndex()) {
      this.showHideLoading(true);
      this.setupTable();
      Axios.getMasters('boxes/boxes')
        .then((response) => {
          this.tableData = response.data.data;
          this.searchFuse(
            this.tableColumns.map((prop) => {
              return prop.prop;
            })
          );
          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrors(error));
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('boxes');
  },

  destroyed() {
    this.deselectedItemOnMenu('boxes');
  },
};
</script>
